import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";


export const FormPaper = styled(Paper)(({ theme }) => ({
    width: '380px',
    padding: theme.spacing(3),
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    marginLeft: "auto",
    marginRight: "auto",

}));

